import React from 'react'

const InstagramIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      fill="#000"
      d="M11 2.473c2.779 0 3.108.012 4.2.06 1.016.045 1.565.216 1.93.358.484.187.833.415 1.195.776a3.2 3.2 0 01.776 1.195c.142.365.313.918.357 1.93.049 1.096.061 1.425.061 4.2 0 2.779-.012 3.108-.06 4.2-.046 1.016-.216 1.564-.358 1.93a3.217 3.217 0 01-.776 1.195c-.366.365-.711.589-1.195.776-.365.142-.918.312-1.93.357-1.096.049-1.425.06-4.2.06-2.779 0-3.108-.011-4.2-.06-1.016-.045-1.565-.215-1.93-.357a3.216 3.216 0 01-1.195-.776 3.199 3.199 0 01-.776-1.195c-.142-.366-.312-.918-.357-1.93-.049-1.096-.061-1.425-.061-4.2 0-2.779.012-3.108.061-4.2.045-1.016.215-1.565.357-1.93.187-.484.415-.833.776-1.195.366-.365.711-.589 1.195-.776.365-.142.918-.313 1.93-.357 1.092-.049 1.421-.061 4.2-.061zM11 .6C8.177.6 7.823.612 6.714.66 5.61.71 4.85.889 4.191 1.145a5.076 5.076 0 00-1.844 1.203 5.096 5.096 0 00-1.203 1.84C.89 4.85.71 5.605.661 6.71.612 7.823.601 8.177.601 11s.011 3.177.06 4.286c.049 1.105.228 1.865.483 2.523a5.076 5.076 0 001.203 1.844 5.082 5.082 0 001.84 1.199c.662.256 1.418.434 2.523.483 1.11.049 1.463.06 4.286.06 2.823 0 3.177-.011 4.286-.06 1.105-.049 1.865-.227 2.523-.483a5.083 5.083 0 001.84-1.199 5.083 5.083 0 001.198-1.84c.256-.662.435-1.418.484-2.523.049-1.11.06-1.462.06-4.286 0-2.823-.011-3.177-.06-4.286-.049-1.105-.228-1.865-.484-2.523a4.87 4.87 0 00-1.19-1.848 5.084 5.084 0 00-1.84-1.199C17.15.892 16.395.714 15.29.665 14.177.612 13.824.6 11 .6z"
    ></path>
    <path
      fill="#000"
      d="M11 5.658A5.343 5.343 0 005.658 11 5.343 5.343 0 0011 16.342 5.344 5.344 0 0016.342 11 5.343 5.343 0 0011 5.658zm0 8.807a3.466 3.466 0 11.001-6.931 3.466 3.466 0 010 6.931zM17.8 5.446a1.248 1.248 0 11-2.494 0 1.248 1.248 0 012.495 0z"
    ></path>
  </svg>
)

export default InstagramIcon
